import React, { useState } from "react";

const LLP = () => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  const handleAppointmentClick = () => {
    window.open(
      "http://topmate.io/sanjay_nathani/?utm_source=topmate&utm_medium=popup&utm_campaign=Page_Ready",
      "_blank"
    );
  };

  return (
    <div className="p-4 sm:p-8 bg-gray-100">
      {/* Title */}
      <h1 className="text-2xl sm:text-3xl font-bold text-center mb-6">
        LLP Registration
      </h1>
      <p className="text-gray-700 text-sm sm:text-base lg:text-lg text-center mb-6">
        The limited liability partnership (LLP) is a partnership structure that
        affords certain partners, contingent upon the governing jurisdiction,
        defined limitations on their liability. This pertains specifically to
        liability arising from the misconduct or negligence of another partner.
      </p>

      {/* Collapsible Sections */}
      <div className="space-y-4 mx-4 sm:mx-10 lg:mx-40">
        {/* Section 1 */}
        <div
          className={`border rounded-lg ${
            openSection === 1 ? "bg-blue-100" : "bg-[#005A8C]"
          }`}
        >
          <button
            onClick={() => toggleSection(1)}
            className="w-full text-left px-4 py-3 text-white font-bold flex justify-between items-center"
          >
            1. Features of LLP Company
            <span>{openSection === 1 ? "-" : "+"}</span>
          </button>
          {openSection === 1 && (
            <div className="px-4 py-3 bg-white text-gray-700">
              <ul className="list-disc pl-5 mt-2 space-y-2">
                <li>It has a separate legal entity.</li>
                <li>The liability of each partner is limited to the contribution made by them.</li>
                <li>The cost of forming and running LLP is low compared to companies.</li>
                <li>Less compliance and regulations</li>
                <li>No requirement of minimum capital contribution</li>
                <li>Compulsory Audit is required only when the Contribution exceeds 25 lakhs or the Annual Turnover exceeds 40 Lakhs.</li>
              </ul>
            </div>
          )}
        </div>

        {/* Section 2 */}
        <div
          className={`border rounded-lg ${
            openSection === 2 ? "bg-blue-100" : "bg-[#005A8C]"
          }`}
        >
          <button
            onClick={() => toggleSection(2)}
            className="w-full text-left px-4 py-3 text-white font-bold flex justify-between items-center"
          >
            2. Basic Requirements To Incorporate An LLP
            <span>{openSection === 2 ? "-" : "+"}</span>
          </button>
          {openSection === 2 && (
            <div className="px-4 py-3 bg-white text-gray-700">
              <ul className="list-disc pl-5 mt-2 space-y-2">
                <li>Minimum 2 Designated Partners</li>
                <li>Digital Signature Of One Designated Partner</li>
                <li>DPI Of All The Partners</li>
                <li>
                  The Contribution (Tangible Or Intangible Property Or Other
                  Benefits To The Limited Liability Partnership)
                </li>
                <li>At Least One Designated Partner Is Indian Resident</li>
              </ul>
            </div>
          )}
        </div>

        {/* Section 3 */}
        <div
          className={`border rounded-lg ${
            openSection === 3 ? "bg-blue-100" : "bg-[#005A8C]"
          }`}
        >
          <button
            onClick={() => toggleSection(3)}
            className="w-full text-left px-4 py-3 text-white font-bold flex justify-between items-center"
          >
            3. Documents Required
            <span>{openSection === 3 ? "-" : "+"}</span>
          </button>
          {openSection === 3 && (
            <div className="px-4 py-3 bg-white text-gray-700">
              <ul className="list-disc pl-5 mt-2 space-y-2">
                <p>The following documents are generally required for LLP Registration in India:</p>
                <p className="font-bold">Documents of all Partners:</p>
                <li>Identity Proof: PAN Card, Aadhaar Card, Voter ID Card, or Driving License</li>
                <li>Address Proof: Passport, Aadhaar Card, Voter ID Card, or Driving License</li>
                <li>Residence Proof: Recent utility bills (electricity, water, gas, telephone) or bank statement (not older than 2-3 months)</li>
                <li>Passport-size Photograph: With a white background</li>
                <p className="font-bold">Registered Office Proof:</p>
                <li>Utility Bills: Electricity bill, water bill, gas bill, or telephone bill (not older than 2 months)</li>
                <li>Tax Receipt: Property tax receipt</li>
                <li>Rent Agreement: If the office is rented, a rent agreement and NOC from the landlord are required</li>
                <p className="font-bold">Other Documents:</p>
                <li>Digital Signature Certificate (DSC) of at least one Designated Partner</li>
                <li>Director Identification Number (DIN) of all Designated Partners</li>
                <p className="font-bold">Note:</p>
                <li>The specific requirements may vary slightly depending on the jurisdiction and the nature of the LLP.</li>
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* Get in Touch Section */}
      <div className="mt-8 bg-gray-50 p-6 rounded-md shadow-sm mx-4 sm:mx-10 lg:mx-40">
        <h2 className="text-lg sm:text-xl font-semibold mb-4">Get in touch</h2>
        <p className="text-gray-700 mb-6">
          If you have any queries or questions, please reach out to us by
          clicking on the contact button and filling out the form.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-y-4 sm:gap-x-4">
          {/* Make Appointment Button */}
          <button
            onClick={handleAppointmentClick}
            className="px-6 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 transition duration-200"
          >
            Make Appointment
          </button>

          {/* Contact Us Button */}
          <button className="px-6 py-2 bg-[#005A8C] text-white rounded  transition duration-200">
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
};

export default LLP;
